import React, { useState, useEffect } from 'react';
import ComanServices from '../../services/ComanServices'; // Assuming this is where your service is

function ContactUs() {
  const [contactData, setContactData] = useState({
    email: '',
    phone: '',
    officeAddress: '',
    city: '',
    message: '',
    faceBook: '',
    whatsApp: '',
    linkdin: '',
    instagram: ''
  });

  // Fetch data when the component mounts
  useEffect(() => {
    ComanServices.getContact().then((response) => {
      if (response.status && response.data) {
        const data = response.data;
        setContactData({
          email: data.email || '',
          phone: data.whatsApp || '',
          officeAddress: data.officeAddress || '',
          city: data.city || '',
          message: data.message || '',
          faceBook: data.faceBook || '',
          whatsApp: data.whatsApp || '',
          linkdin: data.linkdin || '',
          instagram: data.instagram || ''
        });
      }
    }).catch((error) => {
      console.error('Error fetching contact data', error);
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContactData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Call the update API with the updated contact data
    ComanServices.updateContact(contactData).then((response) => {
      if (response.status) {
        alert('Contact updated successfully');
      }
    }).catch((error) => {
      console.error('Error updating contact data', error);
    });
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Contact us</h2>
      </div>
      <div className="container-box px-5">
        <div className="container-box-inner">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-6">
                  <div className="input-field">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      value={contactData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="input-field">
                    <label>Phone</label>
                    <input
                      type="text"
                      name="whatsApp"
                      className="form-control"
                      value={contactData.whatsApp}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="input-field">
                    <label>Office Address</label>
                    <input
                      type="text"
                      name="officeAddress"
                      className="form-control"
                      value={contactData.officeAddress}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="input-field">
                    <label>City</label>
                    <input
                      type="text"
                      name="city"
                      className="form-control"
                      value={contactData.city}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Message</label>
                    <textarea
                      className="form-control"
                      cols={3}
                      style={{ height: "auto" }}
                      name="message"
                      value={contactData.message}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Facebook Link</label>
                    <div className="input-link-outer">
                      <input
                        type="text"
                        name="faceBook"
                        className="form-control"
                        value={contactData.faceBook}
                        onChange={handleChange}
                      />
                      <button className="link-copy-btn">
                        <i className="fa fa-paperclip" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>WhatsApp Link</label>
                    <div className="input-link-outer">
                      <input
                        type="text"
                        name="whatsApp"
                        className="form-control"
                        value={contactData.whatsApp}
                        onChange={handleChange}
                      />
                      <button className="link-copy-btn">
                        <i className="fa fa-paperclip" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>LinkedIn Link</label>
                    <div className="input-link-outer">
                      <input
                        type="text"
                        name="linkdin"
                        className="form-control"
                        value={contactData.linkdin}
                        onChange={handleChange}
                      />
                      <button className="link-copy-btn">
                        <i className="fa fa-paperclip" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="input-field">
                    <label>Instagram Link</label>
                    <div className="input-link-outer">
                      <input
                        type="text"
                        name="instagram"
                        className="form-control"
                        value={contactData.instagram}
                        onChange={handleChange}
                      />
                      <button className="link-copy-btn">
                        <i className="fa fa-paperclip" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <button className="submit-green-btn">SUBMIT</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
